<script setup lang="ts">
interface Props {
  readonly message: string;
  readonly onRetry?: () => void;
}
defineProps<Props>();
</script>

<template>
  <div class="state-block state-block--error" role="alert">
    <div class="state-block__icon" aria-hidden="true">!</div>
    <div class="state-block__title">出错了</div>
    <div class="state-block__body">{{ message }}</div>
    <button
      v-if="onRetry"
      type="button"
      class="btn"
      @click="onRetry"
    >
      重试
    </button>
  </div>
</template>
